// Archivo: content/termsOfUseContent.js
export const termsOfUseContent = [
    {
      title: "Introduction",
      content: "By accessing or using our platform, you agree to be bound by these Terms of Use. If you do not agree with any part of these terms, you must not use the platform."
    },
    {
      title: "Account Registration",
      content: "To access certain features, you may need to register an account. You agree to provide accurate, current, and complete information during registration. You are also responsible for maintaining the confidentiality of your account credentials."
    },
    {
      title: "User Responsibilities",
      content: "You are responsible for all activities under your account and agree to use the platform only for lawful purposes. You must comply with all applicable laws and regulations while using the platform."
    },
    {
      title: "Content Ownership",
      content: "All content on the platform, including templates, designs, code, and digital assets, is owned by the platform or its licensors and is protected by copyright laws. You may not use the content for commercial purposes without permission or distribute it to third parties without authorization."
    },
    {
      title: "Prohibited Conduct",
      content: "You agree not to engage in any activity that may harm the platform or its users, including but not limited to: unauthorized access, distributing malware, violating intellectual property rights, or engaging in harassment or fraudulent activities."
    },
    {
      title: "User-Generated Content",
      content: "If you upload or submit any content to the platform, you grant the platform a worldwide, royalty-free, non-exclusive license to use, display, and distribute such content for the purposes of operating and promoting the platform."
    },
    {
      title: "Payments and Refunds",
      content: "All payments for templates and services are processed securely through third-party payment gateways. Refunds may be requested within a specific period if the product is defective or does not meet the description. Refer to our Refund Policy for more details."
    },
    {
      title: "Limitation of Liability",
      content: "The platform is not liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use the platform, including but not limited to loss of data, profits, or business opportunities."
    },
    {
      title: "Indemnification",
      content: "You agree to indemnify and hold the platform harmless from any claims, damages, or expenses arising from your use of the platform or violation of these Terms of Use."
    },
    {
      title: "Termination",
      content: "We reserve the right to suspend or terminate your account at any time for violating these Terms of Use. Upon termination, you must cease all use of the platform, and any payments made are non-refundable."
    },
    {
      title: "Privacy",
      content: "Your use of the platform is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information. By using the platform, you consent to our data practices as outlined in the Privacy Policy."
    },
    {
      title: "Changes to the Platform",
      content: "We may modify, suspend, or discontinue the platform or any part of it at any time, without notice. We are not liable for any interruptions or unavailability of the platform."
    },
    {
      title: "Modifications to These Terms",
      content: "We may update or modify these Terms of Use at any time. Any changes will be posted on the platform, and your continued use of the platform constitutes acceptance of those changes. Please review these terms regularly to stay informed."
    },
    {
      title: "Governing Law",
      content: "These Terms of Use are governed by and construed in accordance with the laws of the jurisdiction in which the platform is operated. Any disputes arising from these terms will be resolved in the courts of that jurisdiction."
    },
    {
      title: "Contact Us",
      content: "If you have any questions, concerns, or comments regarding these Terms of Use, please contact us at support@yourwebsite.com. We are here to assist you."
    }
  ];
  